import React from "react";
import { Image } from '../../../ui';
import { getProductImageUrl } from '../../../library/helpers/product-image.js';
import styles from './quotation-item.module.scss';
import PropTypes from 'prop-types';
import { SmallSection } from "../../design";
import SpecificationsDescription from "../specifications-description";
const QuotationDetailsSection = ({ detail, comment }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.image}>
                    {detail.item.product.main_photos?.[0] && <Image src={getProductImageUrl(detail.item.product.main_photos[0])}
                    />}
                </div>
                <p className={styles.imageTag}>Image is for illustration.Real product may vary</p>
            </div>
            <div className={styles.right}>
                <SpecificationsDescription
                    specifications={detail.specifications}
                    hiddenSpecifications={detail.item_hidden_specifications}
                />

                {comment && <i><b>Comment from Leoprinting :</b> {comment}</i>}
            </div>
        </div>
    );
}

QuotationDetailsSection.propTypes = {
    detail: PropTypes.object.isRequired,
    comment: PropTypes.string
}
export default QuotationDetailsSection


export const CombiQuotationDetailsSection = ({ detail, comment }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.image}>
                    {detail.item.product.main_photos?.[0] && <Image src={getProductImageUrl(detail.item.product.main_photos[0])}
                    />}
                </div>
                <p className={styles.imageTag}>Image is for illustration.Real product may vary</p>
            </div>
            <div className={styles.right}>
                <h3>Specifications :</h3>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    {detail.specifications.map(({ data, quantity, item_id, countries }) => (
                        <SmallSection key={item_id} header={(
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="">Quantity : {quantity}</div>
                                    <div className="">Item Id : {item_id}</div>
                                </div>
                                <p>Countries : {countries.filter((value, index, array) => array.indexOf(value) === index).toString()}</p>
                            </div>

                        )}>
                            <SpecificationsDescription
                                specifications={data}
                                title="Specifications"
                                titleLevel={4}
                            />
                        </SmallSection>
                    ))}
                </div>
                {comment && <i><b>Comment from Leoprinting :</b> {comment}</i>}
            </div>
        </div>
    );
}

CombiQuotationDetailsSection.propTypes = {
    detail: PropTypes.object.isRequired,
    comment: PropTypes.string
}
